import { HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useRoutes } from 'react-router-dom';
import './App.css';
import { CustomThemeProvider } from './context/ThemeContext';
import { TourDateProvider } from './context/TourDateContext';
import Routes from './shared/Routes';
import SplashScreen from './SplashScreen';

const lngs = {
  hr: { nativeName: 'Croatian' },
  en: { nativeName: 'English' },
  de: { nativeName: 'Deutsch' }
}
const helmetContext = {}

function App() {
  const { t, i18n } = useTranslation();
  var element = useRoutes(Routes)

  return (
    <HelmetProvider context={helmetContext}>
      <CustomThemeProvider>
        <TourDateProvider>
          <SplashScreen />
          {element}
        </TourDateProvider>
      </CustomThemeProvider>

    </HelmetProvider>
    // <div>
    //   {Object.keys(lngs).map((lng) => (
    //     <button key={lng} style={{ fontWeight: i18n.resolvedLanguage === lng ? 'bold' : 'normal' }} type="submit" onClick={() => i18n.changeLanguage(lng)}>
    //       {lngs[lng as keyof typeof lngs].nativeName}
    //     </button>
    //   ))}
    // </div>
  );
}

export default App;
